import React from "react";
import { connect } from "react-redux";

import RadioButton from "../inputform/RadioButton";
import { IAppState } from "../../state/Store";
import { DisplayType } from "../../types/system/DisplayType";
import { setWorking } from "../../state/system/Display";
import Checkbox from "../inputform/Checkbox";
import Panel from "../panels/Panel";
import { Side, FlexDirection } from "../../types/system/Layout";

interface DisplaySettingReportSectionProps {
    setting: DisplayType;
    setWorking: (display: Partial<DisplayType>) => void;
}

interface DisplaySettingReportSectionState {}

class DisplaySettingReportSection extends React.Component<
    DisplaySettingReportSectionProps,
    DisplaySettingReportSectionState
> {
    render() {
        return (
            <Panel
                bufferSide={Side.All}
                flex={FlexDirection.Column}>
                <h3>{this.props.setting.name}</h3>

                {this.props.setting.additional
                    .filter(
                        item => item.title().length !== 0 && item.show === true,
                    )
                    .map((additionalSetting, index) => (
                        <div key={index}>
                            <div>
                                {additionalSetting.options && (
                                    <div
                                        className="pane buffer"
                                        ng-if="!!additionalSetting.options">
                                        <h4>
                                            <b>{additionalSetting.title()}</b>
                                        </h4>
                                        {additionalSetting.options.map(
                                            (option, index) => (
                                                <RadioButton
                                                    key={index}
                                                    className="flex left-buffer"
                                                    name={
                                                        this.props.setting.type
                                                    }
                                                    value={option.value}
                                                    label={option.text}
                                                    checked={
                                                        additionalSetting.value ===
                                                        option.value
                                                    }
                                                    onChange={value =>
                                                        this.props.setWorking({
                                                            type: this.props
                                                                .setting.type,
                                                            additional: [
                                                                {
                                                                    type: additionalSetting.type,
                                                                    options: [
                                                                        {
                                                                            text: option.text,
                                                                            value: value,
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        })
                                                    }
                                                />
                                            ),
                                        )}
                                    </div>
                                )}
                                {!additionalSetting.options && (
                                    <Checkbox
                                        label={additionalSetting.title()}
                                        value={additionalSetting.value}
                                        onChange={value =>
                                            this.props.setWorking({
                                                type: this.props.setting.type,
                                                additional: [
                                                    {
                                                        type: additionalSetting.type,
                                                        value: value,
                                                    },
                                                ],
                                            })
                                        }
                                    />
                                )}
                            </div>
                        </div>
                    ))}
            </Panel>
        );
    }
}

const mapStateToProps = (state: IAppState) => {
    const {} = state;
    return {};
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        setWorking: (display: Partial<DisplayType>) =>
            dispatch(setWorking(display)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(DisplaySettingReportSection);
